import React from 'react'
import { Modal, Form, Button } from 'antd'
import { connect } from 'react-redux'
import ButtonPurple from 'components/design/Form/ButtonPurple'
import style from './style.module.scss'
// import customLanguageTexts from '../../../language'

const mapStateToProps = ({ settings: { visibleModalID } }) => ({ visibleModalID })

@connect(mapStateToProps)
class ModalFilterApp extends React.Component {
  handleCancel = () => {
    const { dispatch } = this.props
    dispatch({
      type: 'settings/CHANGE_SETTING',
      payload: {
        setting: 'visibleModalID',
        value: '',
      },
    })
  }

  render() {
    const { visibleModalID } = this.props
    const modalID = 'appFilter'
    const visible = modalID === visibleModalID

    return (
      <Modal className={style.modal} open={visible} footer={null} onCancel={this.handleCancel}>
        <Form className={style.filterFormContainer}>
          <div className={style.role}>Role</div>
          <select
            id="dropdown"
            onChange={this.handleDropdownChange}
            placeholder="Role"
            defaultValue="none"
          >
            {/* <option value="N/A">N/A</option> */}
            <option value="admin">Admin</option>
            <option value="developer">Developer</option>
            <option value="moderator">Moderator</option>
          </select>
          <div className={style.role}>Plan</div>
          <select id="dropdown" onChange={this.handleDropdownChange}>
            {/* <option value="N/A">N/A</option> */}
            <option value="admin">Admin</option>
            <option value="developer">Developer</option>
            <option value="moderator">Moderator</option>
          </select>
        </Form>
        <div className={style.footerContainer}>
          <div className={style.buttonContainer}>
            <Button className={style.resetButton}> Reset </Button>
            <ButtonPurple className={style.applyButton} buttonText="Apply" />
          </div>
        </div>
      </Modal>
    )
  }
}

export default ModalFilterApp
